
var Subscribe = function () {
    var initNewsletterForm = function ($form) {

        $form.submit(function(e) {
            e.preventDefault();
        }).validate({
            errorElement: 'div', //default input error message container
            errorClass: 'invalid-feedback', // default input error message class
            focusInvalid: true, // do not focus the last invalid input
            ignore: "",
            rules: {
                first_name: {
                    required: true,
                },
                last_name: {
                    required: true,
                },
                email: {
                    required: true,
                    email: true
                },
                email_confirmation: {
                    required: true,
                    email: true,
                    equalTo: "#email",
                },
                eula: {
                    required: true,
                },
            },
            messages: {

                first_name: {
                    required: window.trans('fgsz.newsletter.first_name_required'),
                },
                last_name: {
                    required: window.trans('fgsz.newsletter.last_name_required'),
                },
                email: {
                    required: window.trans('fgsz.newsletter.email_required'),
                    email: window.trans('fgsz.newsletter.email_is_not_valid')
                },
                email_confirmation: {
                    required: window.trans('fgsz.newsletter.email_confirmation_required'),
                    equalTo: window.trans('fgsz.newsletter.email_confirmation'),
                    email:  window.trans('fgsz.newsletter.email_is_not_valid')
                },
                eula: {
                    required:  window.trans('fgsz.newsletter.eula_required'),
                }
            },
            highlight: function (element) { // hightlight error inputs
                $(element).closest('.form-group').addClass('is-invalid'); // set error class to the control group
            },

            success: function (label) {
                label.closest('.form-group').removeClass('is-invalid');
                label.closest('.form-group').removeClass('is-valid');
                label.remove();
            },

            submitHandler: function (form) {
                submit(form, "#subscribe");
            }
        });

        $form.keypress(function (e) {
            if (e.which == 13) {
                if ($form.validate().form()) {
                    $form.submit();
                }
                return false;
            }
        });

    };

    var initUnsubscribeForm = function ($form) {
        $form.submit(function(e) {
            e.preventDefault();
        }).validate({
            errorElement: 'div', //default input error message container
            errorClass: 'invalid-feedback', // default input error message class
            focusInvalid: true, // do not focus the last invalid input
            ignore: "",
            rules: {
                email: {
                    required: true,
                    email: true
                },
            },
            messages: {
                email: {
                    required: window.trans('fgsz.newsletter.email_required'),
                    email: window.trans('fgsz.newsletter.email_is_not_valid')
                },
            },
            highlight: function (element) { // hightlight error inputs
                $(element).closest('.form-group').addClass('is-invalid'); // set error class to the control group
            },

            success: function (label) {
                label.closest('.form-group').removeClass('is-invalid');
                label.closest('.form-group').removeClass('is-valid');
                label.remove();
            },

            submitHandler: function (form) {
                submit(form, "#unsubscribe");
            }
        });
        $form.keypress(function (e) {
            if (e.which == 13) {
                if ($form.validate().form()) {
                    $form.submit();
                }
                return false;
            }
        });
    };

    var getFormData = function ($form) {
        var unindexed_array = $form.serializeArray();
        var indexed_array = {};

        $.map(unindexed_array, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    };

    var submit = function (form, anchor) {
        var $form = $(form);
        var data = getFormData($form);

        $('.alert-info').addClass('d-none');
        $('.alert-error').addClass('d-none');
        $('.alert-danger').addClass('d-none');
        $(form).find('button').addClass('disabled');
        $(form).find('button').prop('disabled', true);



        axios.post(form.action,data)
        .then(function (response) {
            $(form).find('.alert-info').removeClass('d-none');
            form.reset();
        }).catch(function (error) {
            for(var propertyName in  error.response.data.errors) {
                $(form).find('.alert-danger').text(error.response.data.errors[propertyName][0]);
                $(form).find('.alert-danger').removeClass('d-none');
             }
            $(form).find('.alert-danger').fadeToggle();
        }).then(function () {
            var url = location.href;
            location.href = anchor;
            history.replaceState(null,null,url);
        });
        $(form).find('button').removeClass('disabled');
        $(form).find('button').prop('disabled', false);

        grecaptcha.reset(0);
        grecaptcha.reset(1);
    };


    return {
        //main function to initiate the module
        initNewsletterForm: function ($form) {
            initNewsletterForm($form);
        },
        initUnsubscribeForm: function ($form) {
            initUnsubscribeForm($form);
        }
    };

}();


$(document).ready(function () {
    var $forms = $('.newsletter_form');
    if ($forms.length) {
        $forms.each(function () {
            Subscribe.initNewsletterForm($(this));
        });
    }
    var $forms = $('.newsletter_unsubscribe_form');
    if ($forms.length) {
        $forms.each(function () {
            Subscribe.initUnsubscribeForm($(this));
        });
    }
});


